import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWhatsapp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="M20 5.5c-7.732 0-14 6.268-14 14 0 2.989.936 5.758 2.532 8.032L7 32.5l4.968-1.532A13.94 13.94 0 0 0 20 33.5c7.732 0 14-6.268 14-14s-6.268-14-14-14"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M19.93 21.95a2 2 0 0 0 2.308.375l.25-.125a2 2 0 0 1 2.308.375l2.652 2.651a.5.5 0 0 1-.196.828l-2.414.805c-1.95.65-4.1.142-5.554-1.311l-5.999-6a4.39 4.39 0 0 1-.822-5.064l1.104-2.208a.5.5 0 0 1 .801-.13l2.733 2.733a2 2 0 0 1 .375 2.309l-.125.25a2 2 0 0 0 .374 2.308z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M20 9c6.627 0 12 5.373 12 12 0 3.227-1.278 6.249-3.515 8.485A11.96 11.96 0 0 1 20 33v1c3.59 0 6.84-1.455 9.192-3.808A12.96 12.96 0 0 0 33 21c0-7.18-5.82-13-13-13z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWhatsapp);

export default ForwardRef;
